import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26b20fba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "box-left" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "sub" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub" }, "https://dec.virtueal.cn", -1))
const _hoisted_8 = { class: "btn" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))

import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { clipboardSuccess, clipboardError } from "@/utils";

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadInMobile',
  setup(__props) {

const store = useStore();
const close = () => {
  store.dispatch("changeMobileDownloadTips", false);
};

return (_ctx: any,_cache: any) => {
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock("div", {
    class: "box1",
    onClick: _withModifiers(close, ["self"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("mobile.download_to_pc")), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("mobile.donwload_link")) + ":", 1),
          _hoisted_7,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$t("mobile.copy_link")), 1)
          ])), [
            [_directive_clipboard, `https://dec.virtueal.cn`, "copy"],
            [_directive_clipboard, _unref(clipboardSuccess), "success"],
            [_directive_clipboard, _unref(clipboardError), "error"]
          ])
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", {
        class: "close",
        onClick: close
      }, _toDisplayString(_ctx.$t("mobile.close")), 1)
    ])
  ], 8, _hoisted_1))
}
}

})